export enum CONNECTION_CONFIG_TYPES {
  as2 = 'as2',
  inbound = 'inbound',
  outbound = 'outbound',
}
